import { Grid, Skeleton } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import ServiceItem from '/react4xp/mixins/service-item';
import { getServicesList } from '/react4xp/parts/main/actions';
import { getImgUrl } from '/react4xp/parts/service-link-img/actions';
import '/site/parts/block-service-list/block-service-list.scss';

const { useBreakpoint } = Grid;

const BlockServiceList: FC = (props: any) => {
    const [list, setList] = useState<any[]>();
    const [img, setImg] = useState();
    const { md } = useBreakpoint();

    useEffect(() => {
        getServicesList(props.context).then((value) => {
            const sl = value.data;

            const list = sl.hits
                .filter(Boolean)
                .slice(0, md ? 4 : 3);

            setList(list);
        });

        if (props.image) {
            getImgUrl(props.image).then((value) => {
                if (value.data) {
                    setImg(value.data);
                }
            });
        }
    }, [md]);

    return (
        <div className="service-block">
            {img && (
                <img
                    className="me-2"
                    src={img}
                />
            )}

            <div className="service-block__title">{props.config.serviceTitle}</div>

            {list ? (
                list.map(
                    (x, id) =>
                        x && (
                            <ServiceItem
                                key={id}
                                language={props.language}
                                url={x.url}
                                name={x.name}
                                isExternal={x.isExternal}
                            />
                        )
                )
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 4 }}
                />
            )}

            {props.config.servicePageName && props.config.servicePageUrl && (
                <ServiceItem
                    language={props.language}
                    url={props.config.servicePageUrl}
                    name={props.config.servicePageName}
                    position={'right'}
                />
            )}
        </div>
    );
};

export default BlockServiceList;
